import { call, put, takeLatest } from 'redux-saga/effects';
import { i18n } from 'next-i18next';
import {
  LOGIN,
  LOAD_USER_PROFILE,
  LOAD_USER_PROFILE_SUCCESS,
  LOAD_USER_PROFILE_FAIL,
  SIGN_UP,
  LOGOUT,
} from './constants';
import { savePagesState } from './utils';
import authService from '~/services/authService';
import config from '~/config';
import cookies from '~/services/cookies';

function* login() {
  yield savePagesState();
  let currentLang = i18n.language;
  if (currentLang === 'ja') {
    currentLang = 'jp';
  }
  window.location.href = `${
    config.ssoURL
  }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
    window.location.href,
  )}`;
}

function signUp() {
  let currentLang = i18n.language;
  if (currentLang === 'ja') {
    currentLang = 'jp';
  }
  window.location.href = `${
    config.ssoURL
  }/signup?lang=${currentLang}&serviceURL=${encodeURIComponent(
    window.location.href,
  )}`;
}

function logout(action) {
  let currentLang = i18n.language;
  if (currentLang === 'ja') {
    currentLang = 'jp';
  }
  const sessionID = cookies.get('sessionId');
  cookies.remove('userInfo');
  cookies.remove('sessionId');
  window.location.href = `${
    config.ssoURL
  }/logout?lang=${currentLang}&sessionID=${sessionID}&serviceURL=${encodeURIComponent(
    action.payload.redirectURL || config.redirectURL,
  )}${currentLang === 'jp' ? '' : `/${currentLang}`}`;
}

function* loadProfile(action) {
  try {
    yield put({
      type: LOAD_USER_PROFILE_SUCCESS,
      payload: action.payload,
    });
    const { userInfor } = action.payload;
    if (userInfor) {
      yield call(authService.saveUser, userInfor);
    }
  } catch (error) {
    console.log('--- error 33 ---', error);
    yield put({ type: LOAD_USER_PROFILE_FAIL, error });
  }
}

export default function* auth() {
  yield takeLatest(LOGIN, login);
  yield takeLatest(SIGN_UP, signUp);
  yield takeLatest(LOGOUT, logout);
  yield takeLatest(LOAD_USER_PROFILE, loadProfile);
}
